import axios from "axios";

export default interface GeoEntity {
  iso3: string;
  iso?: string;
  name: string;
  centroid?: [number, number];
  boundingBox?: [number, number, number, number];
}

// Load GeoEntities from the browser if available
let _geoEntities: string = "{}";
_geoEntities = localStorage.getItem("_geoEntities") || _geoEntities;
let GeoEntities: { [key: string]: GeoEntity } = JSON.parse(_geoEntities);

// Load GeoOptions from the browser if available
let _geoOptions: string = "[]";
_geoOptions = localStorage.getItem("_geoOptions") || _geoOptions;
let GeoOptions: GeoEntity[] = JSON.parse(_geoOptions);

fetchLookups();

// fetchLookups loads GeoEntities from the database
async function fetchLookups() {
  try {
    let response = await axios.get("/psql/geo_entities", {
      params: {
        select:
          "iso3,iso,name:idmc_short_name,centroid,boundingBox:boundingbox",
        order: "idmc_short_name",
      },
    });

    GeoOptions = response.data;
    for (const entity of GeoOptions) {
      GeoEntities[entity.iso3] = entity;
    }

    localStorage.setItem("_geoOptions", JSON.stringify(GeoOptions));
    localStorage.setItem("_geoEntities", JSON.stringify(GeoEntities));
  } catch (error) {
    console.error(error.response);
  }
}

// getGeoEntityByISO3 looks up a geo entity by iso3
export function getGeoEntityByISO3(iso3: string): GeoEntity {
  const country = GeoEntities[iso3];
  return country || { iso3, name: "--invalid iso3--" };
}

// getGeoOptions returns a copy of GeoOptions for selects
export function getGeoOptions(): GeoEntity[] {
  return [...GeoOptions];
}
